import { Activity, OperationTypeEnum } from "@finway-group/shared/lib/models"
import { validObjectId } from "./shared"

export const activity = new Activity({
    id: validObjectId,
    operationType: OperationTypeEnum.APPROVE_EXPENSE,
    collectionName: "Collection 1",
    documentId: validObjectId,
    createdBy: validObjectId,
    viewedBy: [validObjectId],
    created: Date.now(),
})
